import { render } from "./RolesContenedorComponent.vue?vue&type=template&id=4f6e464a"
import script from "./RolesContenedorComponent.vue?vue&type=script&lang=js"
export * from "./RolesContenedorComponent.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__